// extracted by mini-css-extract-plugin
export default {"noItemsIcon":"IconActionActionCompare_noItemsIcon__SXCNa"};